import {Modal} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {DialogButton} from 'src/design/molecules/DialogButton';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface CreateConfirmModalProps {
  opened: boolean;
  formId: number;
  onClose: () => void;
}

export const CreateConfirmModal: React.FC<CreateConfirmModalProps> = ({
  opened,
  formId,
  onClose,
}) => {
  const navigate = useAppNavigate();

  const handleGoToFormsList = () =>
    navigate(PathUtility.FormsDashboard('manage'));

  const handleContinueEditing = () =>
    navigate(PathUtility.FormBuilderView(formId));

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Form Created"
      styles={{title: {fontWeight: 700}}}
      closeOnClickOutside={false}
      closeOnEscape={true}
      withCloseButton={true}
      centered>
      <Text size="sm" c="dimmed" mb="lg">
        Your form was successfully saved.
      </Text>
      <Group justify="end">
        <DialogButton
          variant="filled"
          color="green"
          onClick={handleContinueEditing}>
          Continue Editing
        </DialogButton>
        <DialogButton variant="outline" onClick={handleGoToFormsList}>
          Go to Forms List
        </DialogButton>
      </Group>
    </Modal>
  );
};

